
import { Injectable, NgZone } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';


/** An `a` anchor interceptor.
 *  As we can't add `routerLink` code in translation files, we intercept all a hrefs, 
 *  and if they have the data-translink, we use that as a router link.
 *  In your translation file, do `<a data-translink='/link' href='/link'></a>`
 */
@Injectable({ providedIn: 'root' })
export class TranslationLinkDelegationService {
  private started = false;

  constructor(private router: Router, private zone: NgZone) {}

  start() {
    if (this.started)
        return;
    this.started = true;

    // Run outside Angular to avoid triggering change detection on every click
    this.zone.runOutsideAngular(() => {
      document.addEventListener('click', this.onClick, true);
    });
  }

  private onClick = (event: MouseEvent) => {
    const el = event.target as Element | null;
    const anchor = el?.closest?.('a[data-translink]') as HTMLAnchorElement | null;
    if (!anchor)
        return;

    const translink = anchor.dataset['translink'];
    if (!translink)
        return;


    event.preventDefault();
    event.stopPropagation();

    // Re-enter Angular for navigation
    this.zone.run(() => this.router.navigateByUrl(translink));
  };
}